import React from 'react'
import { any, async, fromJSX, loadedAsyncState, onlyIf, Updater, Widget } from 'widgets-for-react'
import { dataLayerServices } from '../../../seo/datalayer'
import { CMSMenuItem } from '../../cmsPage.state'
import { State } from '../../cmsPage.widget'
import { SearchButtonLayout } from '../../searchBar/searchBar.layout'
import { closeSearchBar, setSearchValueToState, setShowToState, setSuggestionsToState } from '../../searchBar/searchBar.state'
import { urlShareSamePathnameOrParts } from '../../utils/link'
import { CMSHeaderLayout, CMSHeaderLayoutClasses } from './cmsSiteHeader.layout'
import { CMSHeaderMenuLayout, CMSHeaderMenuLayoutClasses } from './cmsSiteHeader.menu.layout'
import { CMSSiteHeaderUpdaters, DisplayType, getDisplaySize } from './cmsSiteHeader.state'
import { hideAnnouncementBar, hideTemplatePartial } from '../../utils/layout'
import { SearchBar } from '../../searchBar/searchBar.widget'
import { announcementBarWidget } from '../announcementBar/announcementBar.widget'
import { fieldUpdater } from '@shared/Frontend/utils/fieldUpdater'

const toggleNavToggled = () => document.documentElement.classList.toggle(CMSHeaderLayoutClasses.navOpen)
const removeNavToggled = () => document.documentElement.classList.remove(CMSHeaderLayoutClasses.navOpen)

export const headerResizeObserver = (setState: (_: Updater<State>) => void, currentDisplayType: string) => new ResizeObserver((entries) => {
  if (currentDisplayType == getDisplaySize()) return

  setState(os => {
    const ns = CMSSiteHeaderUpdaters.changeDisplayType(os)
    currentDisplayType = ns.CMSHeaderState.displayType
    return ns
  })
})

export function publicSiteMenuHeaderWidget(currentState: State): Widget<Updater<State>> {
  const { isMenuOpen, searchState } = currentState.CMSHeaderState
  const hideDonationButton: boolean = hideTemplatePartial('donation', currentState.rootModernBlocksState)
  const hideHeaderNav: boolean = hideTemplatePartial('header', currentState.rootModernBlocksState)
  const hideAnnouncement: boolean = hideAnnouncementBar(currentState.rootModernBlocksState)
  const newsLetterPath = '/nieuwsbrief';
  const hideNewsletterButton = window.location.pathname == newsLetterPath;

  return any<Updater<State>>([
    onlyIf(!hideAnnouncement,
      announcementBarWidget(currentState.CMSHeaderState.announcement).map(fieldUpdater<State>()('CMSHeaderState'))
    ),
    fromJSX((setState) => (
      CMSHeaderLayout.WindowEvents(
        headerResizeObserver(setState, currentState.CMSHeaderState.displayType),
        () => {
          removeNavToggled()
          setState(CMSSiteHeaderUpdaters.closeHeader)
        }
      )
    )),
    any<Updater<State>>([
      any<Updater<State>>([
        fromJSX((setState) => (
          <CMSHeaderLayout.Logo
            onClick={() => {
              removeNavToggled()
              setState(CMSSiteHeaderUpdaters.closeHeader)
            }}
          />
        )),
        onlyIf(!hideHeaderNav,
          any<Updater<State>>([
            fromJSX(() => (
              <CMSHeaderMenuLayout.DonateButton
                onClick={() => { }}
                hide={hideDonationButton}
              />
            )),
            fromJSX((setState) => (
              <CMSHeaderLayout.Toggler
                isMenuOpen={isMenuOpen}
                onToggle={() => {
                  toggleNavToggled()
                  setState(CMSSiteHeaderUpdaters.toggleHeader)
                }}
              />
            )),
          ]).wrapHTML((ie) => CMSHeaderLayout.NavExtraMobile(ie))
        ),
      ]).wrapHTML((ie) => CMSHeaderLayout.NavTop(ie)),

      onlyIf(!hideHeaderNav,
        any<Updater<State>>([
          primaryMenuWidget(currentState, 'desktop').wrapHTML((ie) => CMSHeaderLayout.NavMain(ie)),

          any<Updater<State>>([
            fromJSX((setState) => (
              currentState.isCustomPage != 'searchPageState' ?
                <SearchButtonLayout
                  display='desktop'
                  show={searchState.show}
                  setShow={(show) => setState((state) => setShowToState(show)(state))}
                />
                : <></>
            )),

            fromJSX(() => (
              <CMSHeaderMenuLayout.DonateButton
                onClick={() => { }}
                hide={hideDonationButton}
              />
            )),
          ]).wrapHTML((ie) => CMSHeaderLayout.NavExtraDesktop(ie)),

          fromJSX((setState) => (
            currentState.isCustomPage != 'searchPageState' ?
              <SearchBar
                show={searchState.show}
                searchValue={searchState.searchValue}
                suggestions={searchState.suggestions}
                updateSearchValue={(searchValue) => setState((state) => setSearchValueToState(searchValue)(state))}
                updateSuggestions={(suggestions) => setState((state) => setSuggestionsToState(suggestions)(state))}
                setShow={(show) => setState((state) => setShowToState(show)(state))}
              />
              : <></>
          ))
        ]).wrapHTML((ie) => CMSHeaderLayout.NavDesktop(ie))
      ),

      onlyIf(!hideHeaderNav,
        onlyIf(currentState.CMSHeaderState.displayType == 'mobile',
          any<Updater<State>>([
            any<Updater<State>>([
              primaryMenuWidget(currentState, 'mobile').wrapHTML((ie) => CMSHeaderLayout.NavMain(ie)),

              any<Updater<State>>([
                fromJSX((setState) => (
                  <CMSHeaderMenuLayout.DonateButton
                    onClick={() => {
                      removeNavToggled()
                      setState(CMSSiteHeaderUpdaters.closeHeader)
                    }}
                    hide={hideDonationButton && hideNewsletterButton}
                    hideLink={true}
                  >
                    <CMSHeaderMenuLayout.NewsletterButton
                      onClick={() => {
                        removeNavToggled()
                        setState(CMSSiteHeaderUpdaters.closeHeader)
                      }}
                      path={newsLetterPath}
                      hide={hideNewsletterButton}
                    />
                  </CMSHeaderMenuLayout.DonateButton>
                ))
              ]).wrapHTML((ie) => CMSHeaderLayout.NavExtraOverlayMobile(ie)),
              any<Updater<State>>([
                fromJSX((setState) => (
                  currentState.isCustomPage != 'searchPageState' ?
                    <SearchBar
                      show={true}
                      searchValue={searchState.searchValue}
                      suggestions={searchState.suggestions}
                      updateSearchValue={(searchValue) => setState((state) => setSearchValueToState(searchValue)(state))}
                      updateSuggestions={(suggestions) => setState((state) => setSuggestionsToState(suggestions)(state))}
                      setShow={(show) => setState((state) => setShowToState(show)(state))}
                    />
                    : <></>
                )),
              ]),
            ]).wrapHTML((ie) => CMSHeaderLayout.NavOverlayMobile(ie, isMenuOpen)),
            fromJSX((setState) => (
              currentState.isCustomPage != 'searchPageState' ?
                <SearchBar
                  show={searchState.show}
                  searchValue={searchState.searchValue}
                  suggestions={searchState.suggestions}
                  updateSearchValue={(searchValue) => setState((state) => setSearchValueToState(searchValue)(state))}
                  updateSuggestions={(suggestions) => setState((state) => setSuggestionsToState(suggestions)(state))}
                  setShow={(show) => setState((state) => setShowToState(show)(state))}
                />
                : <></>
            ))
          ]).wrapHTML((ie) => CMSHeaderLayout.NavMobile(ie))
        )
      )
    ]).wrapHTML((ie) => CMSHeaderLayout.Header(ie, hideHeaderNav))
  ])
}

export function primaryMenuWidget(currentState: State, displayType: 'mobile' | 'desktop'): Widget<Updater<State>> {
  return fromJSX((setState) => (
    <>
      {async(currentState.CMSHeaderState.mainMenuItems).run((menuItemUpdater) => {
        setState((s) => ({
          ...s,
          CMSHeaderState: { ...s.CMSHeaderState, mainMenuItems: menuItemUpdater(s.CMSHeaderState.mainMenuItems) },
        }))
      })}

      <CMSHeaderLayout.primaryMenuItems
        displayType={displayType}
        currentState={currentState}
        setState={setState}
        items={currentState.CMSHeaderState.mainMenuItems.kind == 'loaded' ? currentState.CMSHeaderState.mainMenuItems.value : []}
      />
    </>
  ))
}

export function publicSiteHeaderMenuInnerWidget(currentState: State): Widget<Updater<State>> {
  return fromJSX((setState) => (
    <>
      {async(currentState.CMSHeaderState.mainMenuItems).run((menuItemUpdater) => {
        setState((s) => ({
          ...s,
          CMSHeaderState: { ...s.CMSHeaderState, mainMenuItems: menuItemUpdater(s.CMSHeaderState.mainMenuItems) },
        }))
      })}
      <CMSHeaderLayout.primaryMenuItems
        displayType={currentState.CMSHeaderState.displayType}
        currentState={currentState}
        setState={setState}
        items={currentState.CMSHeaderState.mainMenuItems.kind == 'loaded' ? currentState.CMSHeaderState.mainMenuItems.value : []}
      />
    </>
  ))
}

export function publicSiteHeaderMenu1LevelWidget(
  currentState: State,
  menuItems: CMSMenuItem[],
  displayType: DisplayType
): Widget<Updater<State>> {
  return fromJSX((setState) => (
    <>
      {menuItems?.map((mi, mk) => (
        mi.Children && mi.Children.length > 0 ? (
          <CMSHeaderMenuLayout.ItemDropdown
            linkKey={`sm-l-${mk}-${displayType}`}
            key={`sm-l-${mk}-${displayType}`}
            link={{ url: mi.Url, title: mi.Title, target: '_self', kind: 'link' }}
            isActive={
              mi.Children.find((mii) => urlShareSamePathnameOrParts(window.location.href, mii.Url)) != undefined
            }
            title={mi.Title}
            itemClassNames={CMSHeaderMenuLayoutClasses.navItem}
            classNames={CMSHeaderMenuLayoutClasses.navLink}
            activeClassNames={CMSHeaderMenuLayoutClasses.navLinkActive}
            onClickCallback={() => {
              dataLayerServices.menuItemDataLayer(mi.Title, '')
              removeNavToggled()
              setState(CMSSiteHeaderUpdaters.closeHeader)
            }}
            displayType={displayType}

            children={publicSiteHeader2LevelChildrenWidget(currentState, mi.Children, displayType, mk).run(setState)}
          />
        ) : (
          <CMSHeaderMenuLayout.ItemLink
            linkKey={`sm-l-${mk}-${displayType}`}
            key={`sm-l-${mk}-${displayType}`}
            link={{ url: mi.Url, title: mi.Title, target: '_self', kind: 'link' }}
            isActive={urlShareSamePathnameOrParts(window.location.href, mi.Url)}
            title={mi.Title}
            itemClassNames={CMSHeaderMenuLayoutClasses.navItem}
            classNames={CMSHeaderMenuLayoutClasses.navLink}
            activeClassNames={CMSHeaderMenuLayoutClasses.navLinkActive}
            onClickCallback={() => {
              dataLayerServices.menuItemDataLayer(mi.Title, '')
              removeNavToggled()
              setState(CMSSiteHeaderUpdaters.closeHeader)
            }}
          >
            <span className="link__label">{mi.Title}</span>
          </CMSHeaderMenuLayout.ItemLink>
        )
      ))}
    </>
  ))
}

export function publicSiteHeader2LevelChildrenWidget(
  currentState: State,
  menuItems: Omit<CMSMenuItem, 'Children'>[],
  displayType: DisplayType,
  linkId: number
): Widget<Updater<State>> {
  return fromJSX((setState) => (
    <>
      {menuItems?.map((mi, mk) => (
        <CMSHeaderMenuLayout.ItemDropdownLink
          linkKey={`sm-l-${linkId}-${mk}-${displayType}`}
          key={`sm-l-${mk}-${displayType}`}
          link={{ url: mi.Url, title: mi.Title, target: '_self', kind: 'link' }}
          isActive={urlShareSamePathnameOrParts(window.location.href, mi.Url, true)}
          title={mi.Title}
          itemClassNames={CMSHeaderMenuLayoutClasses.navSubItem}
          classNames={CMSHeaderMenuLayoutClasses.navSubLink}
          activeClassNames={CMSHeaderMenuLayoutClasses.navSubLinkActive}
          onClickCallback={() => {
            dataLayerServices.menuItemDataLayer(mi.Title, '')
            removeNavToggled()
            setState(CMSSiteHeaderUpdaters.closeHeader)
          }}
          displayType={displayType}
        />
      ))}
    </>
  ))
}

export function publicSiteHeaderMenu2LevelWidget(
  currentState: State,
  menuItems: CMSMenuItem[],
  updateMenuItems: (_: (_: CMSMenuItem[]) => CMSMenuItem[]) => void
): Widget<Updater<State>> {
  return fromJSX((setState) => (
    <>
      {menuItems?.map((mi, miIndex) =>
        <CMSHeaderMenuLayout.ItemLink
          linkKey={`sm-l-${miIndex}`}
          link={{ url: mi.Url, title: mi.Title, target: '_self', kind: 'link' }}
          isActive={urlShareSamePathnameOrParts(window.location.href, mi.Url)}
          title={mi.Title}
          itemClassNames={CMSHeaderMenuLayoutClasses.navItem}
          classNames={CMSHeaderMenuLayoutClasses.navLink}
          activeClassNames={CMSHeaderMenuLayoutClasses.navLinkActive}
          onClickCallback={() => {
            removeNavToggled()
            setState(CMSSiteHeaderUpdaters.closeHeader)
          }}
        />
      )}
    </>
  ))
}

// TODO move to `CMSSiteHeaderUpdaters`
function toggleCurrentMenuItem(setState: (_: Updater<State>) => void, mi_index: number, value: boolean) {
  function toggleCurrentMenuItem_Inner(mi_index: number): (_: CMSMenuItem[]) => CMSMenuItem[] {
    return (mis1: CMSMenuItem[]) =>
      mis1.map((mi1, mi1_index) => (mi_index == mi1_index ? { ...mi1, ShowChildren: value } : mi1))
  }

  return setState((s) => {
    let s1 = {
      ...s,
      CMSHeaderState: {
        ...s.CMSHeaderState,
        mainMenuItems:
          s.CMSHeaderState.mainMenuItems.kind == 'loaded'
            ? {
              ...s.CMSHeaderState.mainMenuItems,
              value: toggleCurrentMenuItem_Inner(mi_index)(s.CMSHeaderState.mainMenuItems.value),
            }
            : s.CMSHeaderState.mainMenuItems,
      },
    }
    if (value) {
      s1 = closeSearchBar(s1)
    }
    return s1
  })
}
// TODO move to `CMSSiteHeaderUpdaters`
export function collapseMenuItems(s1: State, menuItems: CMSMenuItem[]) {
  return {
    ...s1,
    CMSHeaderState: {
      ...s1.CMSHeaderState,
      menuItems: loadedAsyncState(menuItems.map((i) => ({ ...i, ShowChildren: false }))),
      isMenuOpen: false,
    },
  }
}
